module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/1cd7b4baaf207b96bcbaf041831a8b71.png";